<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <article class="wrapper wrapper-content main-column full-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
          <h1 class="info-menu view-name">
            <img src="static/img/assets/nav_report_on_2.png" alt="">
            {{$t('okrTreeStr')}}
          </h1>
          <span class="info-right">
          </span>
        </div>
        <div v-if="isLiteMode">
          <b-alert variant="danger" show>{{$t('liteIsStr')}}</b-alert>
        </div>
        <div v-else>
          <!-- /ViewTitleBox -->
          <b-col cols="4">
            <b-btn @click="setUserMe" variant="primary" class="mb-4">{{$t('displayMyselfStr')}}</b-btn>
          </b-col>
          <!-- ViewTitleBox -->
          <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
              <img src="static/img/assets/nav_people_on.png" alt="">
              {{$t('searchUserStr')}}
            </h1>
            <span class="info-right">
            </span>
          </div>
          <!-- /ViewTitleBox -->
          <section class="animated fadeInRight">
            <!-- 1on1item -->
            <div class="ibox">
              <div class="ibox-content">
                <!-- ユーザー検索ボックス -->
                <div class="ibox-title search-box">
                  <div class="row">
                    <div class="col-sm-12">
                      <form @submit.prevent>
                        <div class="input-group">
                          <input v-model="searchText" type="text" class="typeahead_2 form-control" :placeholder="$t('searchWithUserName')">
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div class="ibox-content search-resultview">
                  <ul v-if="searchText == ''">
                    <li><label>{{$t('checkUserStrType')}}</label></li>
                    <li v-if="this.getVisitedUsers.length === 0" class="full-cell"><label>{{$t('notFoundUserStr')}}</label></li>

                    <template v-for="user in getVisitedUsers">
                      <li :key="user.id" v-if="user && user.userInfo && user.userId !== getUserId" class="result-box">
                        <div class="cursor" @click="setUserKey(user.userId)">
                          <span class="search-userimg">
                            <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                            <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                          </span>
                          <div class="search-userinfo">
                            <span class="search-username">{{ user.userInfo.userName }}</span>
                            <span class="search-userdept">{{ user.userInfo.dept }}</span>
                          </div>
                        </div>
                      </li>
                    </template>
                    <!-- </transition-group> -->
                  </ul>
                  <ul v-else>
                    <li><label>{{$t('searchResuleStrType')}}</label></li>
                    <li v-if="Object.keys(this.getUsersBySearchText).length === 0" class="full-cell"><label>{{$t('notFoundUserStr')}}</label></li>
                      <template v-for="(user, key) in getUsersBySearchText">
                        <li :key="user.id" v-if="user && user.userInfo && key !== getUserId" class="result-box">
                          <div class="cursor" @click="setUserKey(key)">
                            <span class="search-userimg">
                              <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                              <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                            </span>
                            <div class="search-userinfo">
                              <span class="search-username">{{ user.userInfo.userName }}</span>
                              <span class="search-userdept">{{ user.userInfo.dept }}</span>
                              <span class="search-userbio">{{ user.userInfo.userBio }}</span>
                            </div>
                          </div>
                        </li>
                      </template>
                    <!-- </transition-group> -->
                  </ul>
                </div>
                <!-- /ユーザー検索ボックス -->
              </div>
            </div>
            <!-- /1on1item -->
          </section>
        </div>
      </article>
      <!-- MainView -->
    </div>
        <div>
        <transition name="fade">
          <div v-if="showModal" class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-container">
                <div class="modal-header">
                  <slot name="header">
                    <span class="search-userimg">
                      <img v-if="getUserInfoById(targetUserId).userIcon" :src="getUserInfoById(targetUserId).userIcon" alt="image" class="img-circle">
                      <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                    </span>
                    <div class="search-userinfo">
                      <span class="search-username">{{getUserInfoById(targetUserId).userName}}</span>
                      <span class="search-userdept">{{ getUserInfoById(targetUserId).dept }}</span>
                    </div>
                  </slot>
                </div>
                <div class="modal-body">
                  <div class="m-body-wrap">
                    <slot name="body">
                      <div v-for="(item, key) in getObjectives" :key="key" :class="{'comp-mark' : getIsComp(item)}" class="ibox">
                        <div @click="selectItem(key)" class="ibox-title cursor">
                          <label>
                            <objective :addMore="true" :itemId="key" :detailView="false" :content="item.contentText" :progress="item.progress ? item.progress : '0'" :setReadOnly="'false'" :objective="true" />
                            <span class="due-date date-color">{{$t('dueDateStr')}} : {{item.dueDate}}</span>
                            <div class="ibox-tools">
                              <span @click.stop.prevent="keyresultOpen(key)" class="info-menu cursor">
                                <button class="btn btn-secondary">
                                  <i :class="{'chevronUp' : !getOkrIsOpen(key)}" class="fa fa-chevron-down"></i>
                                  <span v-if="!getOkrIsOpen(key)">{{$t('indicateItemClose')}}</span>
                                  <span v-else>{{$t('indicateAllNotice')}}</span>
                                </button>
                              </span>
                              <span class="info-right">
                                <span class="info-comment-detail">
                                  <img src="static/img/assets/comment.png">
                                  <span>{{getCommentsByItemId(key, 'objectives').length}}</span>
                                </span>
                                <span class="info-comment-detail">
                                   <img src="static/img/assets/relation_object_list.png">
                                <span>{{ item.relations ? Object.keys(item.relations).length : 0 }}</span>
                                </span>
                                <span class="info-comment-detail">{{$t('createDateString')}} : {{item.createdAt | preparedTime}}</span>
                              </span>
                            </div>
                          </label>
                        </div>
                      <div :class="{'keyResultClose' : getOkrIsOpen(key)}" class="ibox-content key-indent">
                        <div v-for="(keyresult, keyresultId) in getTargetKeyresults(key)" :key="keyresultId" class="ibox-child cursor" :class="{'comp-mark' : getIsComp(keyresult)}">
                          <div @click="selectItem(keyresultId)" class="cursor"><label>
                            <div>
                              <span class="comp"></span>
                              <objective :addMore="true" :itemId="keyresultId" :detailView="false" :content="keyresult.contentText" :progress="keyresult.progress ? keyresult.progress : '0'" :setReadOnly="'false'" :objective="false" />
                            </div>
                            <span class="due-date date-color">{{$t('dueDateStr')}} : {{keyresult.dueDate}}</span>
                            <div class="ibox-tools">
                              <span class="info-menu"></span>
                              <span class="info-right">
                                <span class="info-comment-detail">
                                  <img src="static/img/assets/comment.png"><span>{{getCommentsByItemId(keyresultId,'keyresults').length}}</span>
                                </span>
                                <span class="info-comment-detail">
                                   <img src="static/img/assets/relation_object_list.png">
                                <span>{{ item.relations ? Object.keys(item.relations).length : 0 }}</span>
                                </span>
                                <span class="info-comment-detail">{{$t('createDateString')}} : {{keyresult.createdAt|  preparedTime}}</span>
                              </span>
                            </div>
                          </label></div>
                        </div>
                      </div>
                    </div>
                  </slot>
                </div>
              </div>
              <div class="modal-footer">
                <slot name="footer">
                  <div class="row okr-regist-btnset">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-sm-offset-3"><button @click="onClickCancel" type="button" class="btn btn-danger block m-b">{{ $t('cancelStr') }}</button></div>
                  </div>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import Report1on1Item from '@/components/Report/Report1on1Item'
// import Datepicker from 'vuejs-datepicker'
import ReportRelationsListOkrItem from '@/components/Report/ReportRelationsListOkrItem'
import ReportRelationsListRelItem from '@/components/Report/ReportRelationsListRelItem'
import Objective from '@/components/Okr/Objective'
import moment from 'moment'
import Vue from 'vue'
import Icon from 'vue-awesome'
import Datepicker from 'vuejs-datepicker'
import {i18n, liteMode} from '@/main.js'
import {ja, en, zh} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'ManageOkrSelect',
  components: {
    Icon,
    ReportRelationsListOkrItem,
    ReportRelationsListRelItem,
    Datepicker,
    Objective
  },
  data: function () {
    return {
      tag: 'ManageOkrSelect',
      isLiteMode: liteMode,
      open: true,
      href: location.href,
      title: document.title,
      baseUser: '',
      baseItemKey: '',
      baseOkrKey: '',
      modalKeyresultOpen: {},
      relSrc: [],
      relDst: [],
      targetUserId: '',
      showModal: false,
      searchType: 'dueDate',
      searchText: '',
      searchOpen: true,
      isManager: false,
      // fromDate: moment().subtract(1, 'month').toDate(),
      fromDate: moment().toDate(),
      toDate: moment().toDate(), // 絞り込む時にtoDateは現状は指定されていないのでとりあえず999年後にしておく
      format: 'yyyy/MM/dd',
      datepickerLocale: {
        ja: ja,
        en: en,
        zh_tr: zh
      }
    }
  },
  getters: {
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'ManageOkrSelect'
    },
    checkLanguage () {
      return i18n.locale
    },
    targetUser: {
      get () {
        return this.baseUser
      },
      set (v) {
        this.baseUser = v
      }
    },
    targetOkrKey: {
      get () {
        return this.baseOkrKey
      },
      set (v) {
        this.baseOkrKey = v
      }
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUser'
    ]),
    ...mapGetters('keyResults/', [
      'getKeyresultsByUserId',
      'getKeyresultById',
      'getKeyresultsByParentObjId'
    ]),
    ...mapGetters('objectives/', [
      'getObjectivesByIds',
      'getObjectivesByUserId',
      'getObjectiveById'
    ]),
    ...mapGetters('comments/', [
      'getCommentsByItemId'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    ...mapGetters('users/', [
      'getUsersByText',
      'getUsersByIds',
      'getUserInfoById'
    ]),
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        // return this.getUsers
        return {}
      } else {
        return this.getUsersByText(this.searchText)
      }
    },
    getObjectives () {
      console.log('what?', this.targetUserId, this.getObjectivesByUserId(this.targetUserId, true, true))
      return this.getObjectivesByUserId(this.targetUserId, true, true)
    },
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(Object.keys(currentUser.visitHistory))
        let sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] })
          .filter(key => !this.getMetaIsDeleted(key))
          .map(x => { return recentlyCheckedUsers[x] })
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    targetUserInfo () {
      return {
        userName: '（ユーザ名取得中）',
        userIcon: null,
        ...this.getUserInfoById(this.targetUser)
      }
    }
  },
  created () {
    // this.$root.$on('bv::scrollspy::activate', this.onActivate)
  },
  watch: {
    searchType () {
      console.log('watch:searchType', this.searchType)
    }
  },
  methods: {
    ...mapActions('peoples', {
      setVisit: 'SET_VISIT_HISTORY'
    }),
    onClickCancel: function () {
      this.showModal = false
      this.targetUserId = ''
    },
    openPickerFrom: function () {
      this.$refs.programaticOpenFrom.showCalendar()
    },
    getIsComp: function (item) {
      if (!item) {
        return
      }
      return Object.keys(item).filter(x => x === 'isComplete').length === 0 ? false : item.isComplete
    },
    openPickerTo: function () {
      this.$refs.programaticOpenTo.showCalendar()
    },
    getOkrIsOpen: function (objectiveId) {
      return Object.keys(this.modalKeyresultOpen).filter(x => x === objectiveId).length === 0 ? false : this.modalKeyresultOpen[objectiveId]
    },
    keyresultOpen: function (objectiveId) {
      Vue.set(this.modalKeyresultOpen, objectiveId, Object.keys(this.modalKeyresultOpen).filter(x => x === objectiveId).length === 0 ? true : !this.modalKeyresultOpen[objectiveId])
    },
    getTargetKeyresults (key) {
      // 算出プロパティだと引数がつけられないためmethodに
      return this.getKeyresultsByParentObjId(key)
    },
    isBetweenDate (item) {
      if (!item || !Object.keys(item).length) { return false }
      let dueDate = moment(item.dueDate || 0).format('YYYYMMDD')
      let startDate = item.startDate ? moment(item.startDate || 0).format('YYYYMMDD') : moment(item.dueDate || 0).format('YYYYMMDD')
      let fromDate = moment(this.fromDate).format('YYYYMMDD')
      let toDate = moment(this.toDate).format('YYYYMMDD')
      switch (this.searchType) {
        case 'dueDate':
          return (this.fromDate ? dueDate >= fromDate : true) && (this.toDate ? dueDate <= toDate : true)
        case 'startDate':
          return (this.fromDate ? startDate >= fromDate : true) && (this.toDate ? startDate <= toDate : true)
        case 'active':
          return (this.fromDate ? dueDate >= fromDate : true) && (this.toDate ? startDate <= toDate : true)
      }
    },
    onClickBack () {
      this.open = false
      this.searchOpen = true
    },
    setUserKey (userKey) {
      this.showModal = true
      this.targetUserId = userKey
      if (this.getUserId !== userKey) { this.setVisit(userKey) }
    },
    selectItem: function (key) {
      console.log('selectitem', key, this.targetUserId)
      this.$router.push({path: '/okrTree/' + this.targetUserId + '/' + key + '', params: {userId: this.targetUserId, itemId: key}})
    },
    setUserMe () {
      this.setUserKey(this.getUserId)
      // this.setUserKey(this.$store.getters.getCurrentUserId)
    },
    openDetail: function (value) {
      this.$router.push({ name: 'User', params: { userId: value.userId || this.targetUser, item: value.type } })
    },
    relItemIsVisible: function (key) {
      // const rel = this.getObjectivesByUserId(key)
      let rel
      switch ((key || {}).type) {
        case 'objectives':
          rel = this.getObjectiveById(key.key, key.userId)
          rel.owner = key.userId
          break
        case 'keyresults':
          rel = this.getKeyresultById(key.key, key.userId)
          rel.owner = key.userId
          break
        default:
          console.log('ReportRelations:relItemIsVisible: Unknown type.')
          return false
      }
      return Object.keys(rel).length ? this.itemIsVisible(rel) : false
    },
    itemIsVisible: function (item) {
      const me = this.getCurrentUser
      if (item) {
        if (item.hasOwnProperty('owner') && (item.owner === this.getUserId)) {
          return true
        }
        if (!item.hasOwnProperty('limitedAccess')) {
          return true
        }
        if (item.limitedAccess.hasOwnProperty('limitedUsers')) {
          if (item.limitedAccess.limitedUsers.hasOwnProperty(this.getUserId)) {
            return true
          }
        }
        if (item.limitedAccess.hasOwnProperty('limitedGroups')) {
          if (me.hasOwnProperty('groups')) {
            return Object.keys(item.limitedAccess.limitedGroups).some(x => me.groups.hasOwnProperty(x))
          }
        }
      }
      return false
    },
    clearDate: function (type) {
      if (type === 'from') {
        this.fromDate = ''
      } else {
        this.toDate = ''
      }
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
h4.date-label {
  font-size: 150%;
}
.input-searchType {
  margin: auto 0;
  display: -webkit-inline-box;
  padding-inline-start:1px;
  li:not(:first-child) {
    margin-left: 35px;
  }
  input[type="radio"]~label {
    margin-left: 5px;
  }
}
.search-calendar {
  display: inline-block;
  padding-inline-start:18px;
}
.select-date {
  display: flex;
  margin: auto 0;
}
.report-rel {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.back-btn {
  height: 2.5em;
}
.trisection-wrap {
  height: calc(100% - 5.5em);
}
.trisection-head {
  height: 5em;
}
.trisection {
  height: calc(100% - 7.5em);
  &>div {
    overflow-y: auto;
    // height: calc(72vh);
    height: 100%;
    word-wrap: break-word;
  }
}
.selected {
  .okrItem {
    opacity: .5;
  }
  .target {
    box-shadow: 0 0 .1em .2em #ffcccc;
    .okrItem {
      opacity: 1;
    }
  }
}
.dir-title {
  height: 100%;
  max-height: 6.8rem;
  border: none;
  color: #3e8fe0;
  line-height: 4rem;
}
.trisection-head .flex-box {
  width: 100%;
  align-items: center;
}
.mg-right {
    margin-right: 2rem;
    margin-left: 1rem;
}
.fa-angle-double-left {
  font-size: 1.7em;
  // vertical-align: middle;
}
.bg-info {
      font-size: 12.5px;
      width: 475px;
}

 .flex-option{
    display: flex;
    flex-direction: column;
  }

  .keyResultClose .ibox-child {
    height: 0;
    margin: 0 auto;
    padding-top: 0;
    padding-bottom: 0;
    overflow:  hidden;
    border: none;
  }
  .swal2-container {
    z-index: 100000;
  }
  .fa-chevron-down{
    transition: all 0.2s ease-in-out;
  }
  .chevronUp{
    transform: rotate(180deg);
  }
  .modal-enter-active, .modal-leave-active {
    transition: all .2s ease ;
  }
  .modal-enter, .modal-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/manage/ManageOkrSelect.vue